// src/store.js
import { reactive } from 'vue';

export const store = reactive({
  isLoading: false
});